<template >
  <div class="cola-left">
    <div class="cola-left-subject">
      <!-- 设备 -->
      <cload :distinguish="distinguish" v-show="nowpage == 0 && btnshow" />
      <!-- 设备 -->
      <cloadcm :distinguish="distinguish" v-show="nowpage == 1 && btnshow" />
      <!-- 设备 -->
      <cloadjj :distinguish="distinguish" v-show="nowpage == 2 && btnshow" />
      <!-- 灾害模拟 -->
      <disater :distinguish="distinguish" />
      <!-- 切换按钮 -->
      <div
        v-show="nowpage == 0 && btnshow"
        :class="
          distinguish == 1
            ? 'sulijy'
            : distinguish == -1
              ? 'sulijy2'
              : 'sulijy5'
        "
      >
        <img :src="distinguish == 1 ? image : image1" @click="pitch(1)" alt />
        <span>设备</span>
      </div>
      <div v-show="nowpage == 0 && btnshow" :class="distinguish == 2 ? 'sulijy3' : 'sulijy1'">
        <img :src="distinguish == 2 ? image3 : image2" @click="pitch(2)" alt />
        <span>灾害模拟</span>
      </div>
    </div>
  </div>
</template>
<script>
// 灾害模拟
import disater from "../dp/coallist/disaster.vue";
// 设备
import cload from "./coallist/cloab.vue";
import cloadcm from "./coallist/cloabcm.vue";
import cloadjj from "./coallist/cloabjj.vue";
export default {
  name: "moalLeft",
  data() {
    return {
      distinguish: -1,
      image: require("../../assets/sbdj.png"),
      image1: require("../../assets/mrsb.png"),
      image2: require("../../assets/zhmnmr.png"),
      image3: require("../../assets/zhmndj.png"),
      nowpage: 0
    };
  },
  mounted() {
    this.emit.$on("item", e => {
      this.nowpage = e;
      if (e == 0) {
      } else if (e == 1) {
        // this.pitch(1)
        this.distinguish = -1;
      } else if (e == 2) {
        this.distinguish = -1;
        // this.pitch(1)
      }
    });
  },
  components: {
    disater,
    cload,
    cloadcm,
    cloadjj
  },
  props: {
    btnshow: Boolean
  },
  methods: {
    pitch(i) {
      // 点击两次取消
      if (this.distinguish == i) {
        this.distinguish = -1;
        return;
      }
      this.distinguish = i;
    }
  }
};
</script>

<style lang="less" scoped>
.sulijy {
  width: 4vw;
  height: 4vh;
  position: absolute;
  left: 7vw;
  bottom: 9vh;
  z-index: 3;
  transition: all 1s;
  transform: translateX(0%);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  img {
    width: 60%;
    height: auto;
  }
  span {
    display: block;
    color: #fff;
    font-size: 0.8vw;
  }
}
.sulijy5 {
  width: 4vw;
  height: 4vh;
  position: absolute;
  left: 7vw;
  bottom: 9vh;
  z-index: 3;
  transition: all 1s;
  transform: translateX(130%);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  img {
    width: 60%;
    height: auto;
  }
  span {
    display: block;
    color: #fff;
    font-size: 0.8vw;
  }
}
.sulijy2 {
  width: 4vw;
  height: 4vh;
  position: absolute;
  left: 7vw;
  bottom: 9vh;
  z-index: 3;
  transition: all 1s;
  transform: translateX(0%);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  img {
    width: 60%;
    height: auto;
  }
  span {
    display: block;
    color: #fff;
    font-size: 0.8vw;
  }
}

.sulijy1 {
  width: 4vw;
  height: 4vh;
  position: absolute;
  left: 12vw;
  bottom: 9vh;
  z-index: 3;
  transition: all 1s;
  transform: translateX(0%);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  img {
    width: 60%;
    height: auto;
  }
  span {
    display: flex;
    color: #fff;
    font-size: 0.8vw;
  }
}

.sulijy3 {
  width: 4vw;
  height: 4vh;
  position: absolute;
  left: 12vw;
  bottom: 9vh;
  z-index: 3;
  transition: all 1s;
  transform: translateX(-130%);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  img {
    width: 60%;
    height: auto;
  }
  span {
    display: flex;
    color: #fff;
    font-size: 0.8vw;
  }
}

.cola-left {
  width: 24%;
  height: 100%;
  background-image: url(../../assets/zbj.png);
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow-y: hidden;
  pointer-events: none;
  .cola-left-subject {
    width: 80%;
    height: 95%;
    background-image: url("../../assets/zbk.png");
    background-size: 100% 100%;
    margin-top: 4vh;
    display: flex;
    align-items: center;
    pointer-events: auto;
  }
}
</style>